import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";

export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-b border-slate-100">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2" data-testid="nav-logo">
            <div className="font-bold text-lg md:text-2xl text-[#0f172a]" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Local<span className="text-[#f97316]">Tradies</span>Online
            </div>
          </Link>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/browse" 
              className="text-slate-700 hover:text-[#f97316] font-medium transition-colors"
              data-testid="nav-browse-link"
            >
              Find Tradies
            </Link>
            <Link 
              to="/pricing" 
              className="text-slate-700 hover:text-[#f97316] font-medium transition-colors"
              data-testid="nav-pricing-link"
            >
              Pricing
            </Link>
            <Link 
              to="/join" 
              className="text-slate-700 hover:text-[#f97316] font-medium transition-colors"
              data-testid="nav-join-link"
            >
              Join as Tradie
            </Link>
            <a 
              href="tel:0431775771" 
              className="flex items-center space-x-2 text-slate-700 hover:text-[#f97316] font-medium transition-colors"
              data-testid="nav-phone-link"
            >
              <Phone className="w-4 h-4" />
              <span>0431 775 771</span>
            </a>
          </div>

          {/* Desktop CTA Button */}
          <Link 
            to="/get-quote" 
            className="hidden md:block bg-[#f97316] text-white rounded-full px-6 py-3 font-bold hover:bg-[#ea580c] transition-all shadow-lg hover:shadow-orange-500/25 active:scale-95"
            data-testid="nav-get-quote-btn"
          >
            Get Free Quote
          </Link>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-slate-700 hover:text-[#f97316]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-slate-100 py-4 bg-white">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/browse" 
                className="text-slate-700 hover:text-[#f97316] font-medium px-2 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Find Tradies
              </Link>
              <Link 
                to="/pricing" 
                className="text-slate-700 hover:text-[#f97316] font-medium px-2 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Pricing
              </Link>
              <Link 
                to="/join" 
                className="text-slate-700 hover:text-[#f97316] font-medium px-2 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Join as Tradie
              </Link>
              <a 
                href="tel:0431775771" 
                className="flex items-center space-x-2 text-slate-700 hover:text-[#f97316] font-medium px-2 py-2"
              >
                <Phone className="w-4 h-4" />
                <span>0431 775 771</span>
              </a>
              <Link 
                to="/get-quote" 
                className="bg-[#f97316] text-white rounded-full px-6 py-3 font-bold text-center hover:bg-[#ea580c] transition-all mx-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Get Free Quote
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};